import { render } from "./Home.vue?vue&type=template&id=aed60ee6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=aed60ee6&lang=less&scoped=true"

import exportComponent from "E:\\case\\要点传达商城\\6-5\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed60ee6"]])

export default __exports__